module.exports = __webpack_public_path__ + "img/modalblack1.39a1fa2a.gif";